import React from "react";
import { StyleSheet } from "react-native";
import Svg, { Defs, RadialGradient, Rect, Stop } from "react-native-svg";

/**
 * Shared radial overlay for every Bloom Experience hero background photo
 * (main landing screen + every category details screen — same design).
 * Figma spec: radial-gradient(50% 50% at 50% 50%, rgba(49,49,49,0.08) 0%,
 * rgba(0,0,0,0.4) 100%). expo-linear-gradient (used previously here) only
 * supports linear gradients, so this uses react-native-svg's RadialGradient
 * instead — SVG's default objectBoundingBox units already map cx/cy/r
 * percentages onto the actual element box the same way CSS does.
 */
export function HeroOverlayGradient() {
  return (
    <Svg pointerEvents="none" style={StyleSheet.absoluteFillObject} width="100%" height="100%">
      <Defs>
        <RadialGradient id="heroRadial" cx="50%" cy="50%" r="50%">
          <Stop offset="0%" stopColor="rgb(49,49,49)" stopOpacity={0.08} />
          <Stop offset="100%" stopColor="rgb(0,0,0)" stopOpacity={0.4} />
        </RadialGradient>
      </Defs>
      <Rect x="0" y="0" width="100%" height="100%" fill="url(#heroRadial)" />
    </Svg>
  );
}

export default HeroOverlayGradient;
